// @ts-nocheck
import * as Types from '../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { MaterialCatalog_MaterialBrandFragmentDoc } from '../../../material-catalog/MaterialCatalog.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type DesignPackageAddProductMetadataQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type DesignPackageAddProductMetadataQuery = { __typename?: 'Query', materialBrands: Array<{ __typename?: 'MaterialBrand', id: string, name: string }> };

export type AddProductTliPlaceholderQueryVariables = Types.Exact<{
  placeholderTliId: Types.Scalars['ID']['input'];
}>;


export type AddProductTliPlaceholderQuery = { __typename?: 'Query', takeoffLineItem: { __typename?: 'TakeoffLineItem', id: string, item: { __typename?: 'Item', id: string, name: string, materialAttributeDimensions: Array<{ __typename?: 'MaterialAttributeDimension', id: string, name: string, useInTakeoff: boolean, isAdminManaged: boolean, sortOrder: number, type: { __typename?: 'MaterialAttributeDimensionTypeDetail', code: Types.MaterialAttributeDimensionType }, unitOfMeasure?: { __typename?: 'UnitOfMeasure', id: string, abbreviation: string } | null | undefined, values: Array<{ __typename?: 'MaterialAttributeValue', id: string, textValue: string }> }> } } };

export type AddProductTliPlaceholder_MaterialAttributeDimensionFragment = { __typename?: 'MaterialAttributeDimension', id: string, name: string, useInTakeoff: boolean, isAdminManaged: boolean, sortOrder: number, type: { __typename?: 'MaterialAttributeDimensionTypeDetail', code: Types.MaterialAttributeDimensionType }, unitOfMeasure?: { __typename?: 'UnitOfMeasure', id: string, abbreviation: string } | null | undefined, values: Array<{ __typename?: 'MaterialAttributeValue', id: string, textValue: string }> };

export const AddProductTliPlaceholder_MaterialAttributeDimensionFragmentDoc = gql`
    fragment AddProductTliPlaceholder_MaterialAttributeDimension on MaterialAttributeDimension {
  id
  name
  type {
    code
  }
  useInTakeoff
  isAdminManaged
  sortOrder
  unitOfMeasure {
    id
    abbreviation
  }
  values {
    id
    textValue
  }
}
    `;
export const DesignPackageAddProductMetadataDocument = gql`
    query DesignPackageAddProductMetadata {
  materialBrands(filter: {}) {
    ...MaterialCatalog_MaterialBrand
  }
}
    ${MaterialCatalog_MaterialBrandFragmentDoc}`;

/**
 * __useDesignPackageAddProductMetadataQuery__
 *
 * To run a query within a React component, call `useDesignPackageAddProductMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useDesignPackageAddProductMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDesignPackageAddProductMetadataQuery({
 *   variables: {
 *   },
 * });
 */
export function useDesignPackageAddProductMetadataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<DesignPackageAddProductMetadataQuery, DesignPackageAddProductMetadataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DesignPackageAddProductMetadataQuery, DesignPackageAddProductMetadataQueryVariables>(DesignPackageAddProductMetadataDocument, options);
      }
export function useDesignPackageAddProductMetadataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DesignPackageAddProductMetadataQuery, DesignPackageAddProductMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DesignPackageAddProductMetadataQuery, DesignPackageAddProductMetadataQueryVariables>(DesignPackageAddProductMetadataDocument, options);
        }
// @ts-ignore
export function useDesignPackageAddProductMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<DesignPackageAddProductMetadataQuery, DesignPackageAddProductMetadataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DesignPackageAddProductMetadataQuery, DesignPackageAddProductMetadataQueryVariables>;
export function useDesignPackageAddProductMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DesignPackageAddProductMetadataQuery, DesignPackageAddProductMetadataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DesignPackageAddProductMetadataQuery | undefined, DesignPackageAddProductMetadataQueryVariables>;
export function useDesignPackageAddProductMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DesignPackageAddProductMetadataQuery, DesignPackageAddProductMetadataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DesignPackageAddProductMetadataQuery, DesignPackageAddProductMetadataQueryVariables>(DesignPackageAddProductMetadataDocument, options);
        }
export type DesignPackageAddProductMetadataQueryHookResult = ReturnType<typeof useDesignPackageAddProductMetadataQuery>;
export type DesignPackageAddProductMetadataLazyQueryHookResult = ReturnType<typeof useDesignPackageAddProductMetadataLazyQuery>;
export type DesignPackageAddProductMetadataSuspenseQueryHookResult = ReturnType<typeof useDesignPackageAddProductMetadataSuspenseQuery>;
export type DesignPackageAddProductMetadataQueryResult = ApolloReactCommon.QueryResult<DesignPackageAddProductMetadataQuery, DesignPackageAddProductMetadataQueryVariables>;
export const AddProductTliPlaceholderDocument = gql`
    query AddProductTliPlaceholder($placeholderTliId: ID!) {
  takeoffLineItem(id: $placeholderTliId) {
    id
    item {
      id
      name
      materialAttributeDimensions {
        ...AddProductTliPlaceholder_MaterialAttributeDimension
      }
    }
  }
}
    ${AddProductTliPlaceholder_MaterialAttributeDimensionFragmentDoc}`;

/**
 * __useAddProductTliPlaceholderQuery__
 *
 * To run a query within a React component, call `useAddProductTliPlaceholderQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddProductTliPlaceholderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddProductTliPlaceholderQuery({
 *   variables: {
 *      placeholderTliId: // value for 'placeholderTliId'
 *   },
 * });
 */
export function useAddProductTliPlaceholderQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AddProductTliPlaceholderQuery, AddProductTliPlaceholderQueryVariables> & ({ variables: AddProductTliPlaceholderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AddProductTliPlaceholderQuery, AddProductTliPlaceholderQueryVariables>(AddProductTliPlaceholderDocument, options);
      }
export function useAddProductTliPlaceholderLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AddProductTliPlaceholderQuery, AddProductTliPlaceholderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AddProductTliPlaceholderQuery, AddProductTliPlaceholderQueryVariables>(AddProductTliPlaceholderDocument, options);
        }
// @ts-ignore
export function useAddProductTliPlaceholderSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AddProductTliPlaceholderQuery, AddProductTliPlaceholderQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AddProductTliPlaceholderQuery, AddProductTliPlaceholderQueryVariables>;
export function useAddProductTliPlaceholderSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AddProductTliPlaceholderQuery, AddProductTliPlaceholderQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AddProductTliPlaceholderQuery | undefined, AddProductTliPlaceholderQueryVariables>;
export function useAddProductTliPlaceholderSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AddProductTliPlaceholderQuery, AddProductTliPlaceholderQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AddProductTliPlaceholderQuery, AddProductTliPlaceholderQueryVariables>(AddProductTliPlaceholderDocument, options);
        }
export type AddProductTliPlaceholderQueryHookResult = ReturnType<typeof useAddProductTliPlaceholderQuery>;
export type AddProductTliPlaceholderLazyQueryHookResult = ReturnType<typeof useAddProductTliPlaceholderLazyQuery>;
export type AddProductTliPlaceholderSuspenseQueryHookResult = ReturnType<typeof useAddProductTliPlaceholderSuspenseQuery>;
export type AddProductTliPlaceholderQueryResult = ApolloReactCommon.QueryResult<AddProductTliPlaceholderQuery, AddProductTliPlaceholderQueryVariables>;